import { z } from "zod";

const launchDarklyEndpointSchema = z.union([z.url({ protocol: /^https?$/ }), z.string().regex(/^\/(?!\/)/)]);

export const launchDarklyOptionsSchema = z.object({
	clientSideId: z.string().trim().min(1),
	baseUrl: launchDarklyEndpointSchema,
	streamUrl: launchDarklyEndpointSchema,
	eventsUrl: launchDarklyEndpointSchema,
});

export type LaunchDarklyOptions = z.infer<typeof launchDarklyOptionsSchema>;
